<adapt-not-found-page subTitle="{{error.title}}"
                      description="{{error.message}}"
                      title="{{error.errorCode}}"
                      btnText="Navigate back"
                      routerLink="/">
</adapt-not-found-page>
